var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVcIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 159"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 26",
    d: "M0 0h20v20H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 18A1.741 1.741 0 012 16.25V4.75A1.741 1.741 0 013.75 3h4.875a1.743 1.743 0 011.75 1.75v1.562h6.541a1.743 1.743 0 011.75 1.75v8.188a1.741 1.741 0 01-1.75 1.75zm0-1.75h1.562v-1.562H3.75zm0-3.312h1.562v-1.563H3.75zm0-3.313h1.562V8.062H3.75zm0-3.313h1.562V4.75H3.75zm3.312 9.938h1.563v-1.562H7.062zm0-3.312h1.563v-1.563H7.062zm0-3.313h1.563V8.062H7.062zm0-3.313h1.563V4.75H7.062zm3.313 9.938h6.541V8.062h-6.541v1.563h1.666v1.75h-1.666v1.563h1.666v1.75h-1.666zm3.229-4.875v-1.75h1.75v1.75zm0 3.313v-1.75h1.75v1.75z",
    fill: "#666"
  }))));
}
export default SvgVcIcon;